import React from 'react'
import BaseNotification from './default'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { GET_ACTIVITY } from '../shared/helpers'
import { useQuery } from '@apollo/client'
import { useAppLabel } from '_application'

const Activity = ({
  item,
  acceptAction,
  declineAction,
  isOwnerToPersonConnection,
}) => {
  const appLabel = useAppLabel()
  const intl = useIntl()

  const { data, loading } = useQuery(GET_ACTIVITY, {
    variables: {
      id:
        item?.notification?.payload?.find((p) => p?.key === 'activity')
          ?.value || '',
    },
  })
  const activityLink = data?.getActivity?.id

  const ContentComponent = () => (
    <span>
      {`${intl.formatMessage(
        {
          id: `notificationscenter.notification.message.connect.activity${
            isOwnerToPersonConnection ? '.ownertoperson' : ''
          }`,
        },
        {
          entity: `${
            isOwnerToPersonConnection
              ? appLabel('activites', 'activities.title').toLowerCase()
              : ''
          }`,
        }
      )} `}
      <Link to={`/activities/list/${activityLink}`}>
        {data?.getActivity?.name}
      </Link>
    </span>
  )

  if (!data || loading) return null

  return (
    <BaseNotification
      item={item}
      acceptAction={acceptAction}
      declineAction={declineAction}
      ContentComponent={ContentComponent}
    />
  )
}

export default Activity
